const t = (o) => ({
  wrapper: {},
  accordianTitleWrapper: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  accordianTitle: {
    color: o.palette.common.blue400,
    fontSize: o.typography.fontSize18,
    lineHeight: "1.2",
    textAlign: "left",
    "@media(max-width: 600px)": {
      fontSize: o.typography.fontSize16
    }
  },
  expandIcon: {
    color: o.palette.common.purple400,
    marginRight: 8,
    minWidth: 24,
    "&:nth-of-type(1)": {
      fontSize: o.typography.fontSize24
    }
  },
  divider: {
    backgroundColor: o.palette.common.grey50
  },
  accordianContent: {
    color: o.palette.common.grey500,
    "& p": {
      margin: 0,
      marginBottom: "1em",
      "&:last-child": {
        marginBottom: 0
      }
    },
    "& ul, & ol": {
      paddingLeft: "2em"
    }
  }
}), n = t;
export {
  n as default
};
